module.exports = __webpack_public_path__ + "static/img/023多语言版本英语14.9f6e546.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/023多语言版本英语14.jpg
// module id = /ZPR
// module chunks = 0